export const calendarEn = {
  weekNumber: 'A Week №',
  current: 'Today',
  allDay: 'All day',
  executor: 'Executor',
  location: 'Location',
  withStartDate: 'With start date',
  from: 'From',
  to: 'To',
  noColumn: 'There is no column on this board where you can add a task',
  deadline: 'Deadline',
  noRightToSetDeadline: 'You have no right to set a deadline',
  showMore: 'Show more'
}

export const calendarRu: typeof calendarEn = {
  weekNumber: 'Неделя №',
  current: 'Сегодня',
  allDay: 'Весь день',
  executor: 'Исполнитель',
  location: 'Расположение',
  withStartDate: 'C датой начала',
  from: 'C',
  to: 'До',
  noColumn: 'На этой доске нет ни одной колонки, куда можно добавить задачу',
  deadline: 'Дедлайн',
  noRightToSetDeadline: 'Вы не имеете права устанавливать дедлайн',
  showMore: 'Показать ещё'
}
